import BlipData from './BlipData';

export default BlipData;
